// "Regenerar las N imágenes malas": un pedido por imagen, en secuencia (cada uno cobra y
// valida por su cuenta), y UNA tanda con todo lo que salió. Puro: la red se inyecta.
import type { RegeneracionLanzada } from './tipos';

export interface Lanzada {
  imagen_id: string;
  execution_id: string;
  creditos: number;
  formato: string | null;
}

export async function lanzarRegeneraciones(
  ids: readonly string[],
  deps: {
    regenerar: (id: string, executionId: string) => Promise<RegeneracionLanzada>;
    uuid: () => string;
  },
): Promise<{ lanzadas: Lanzada[]; fallo: { imagen_id: string; error: unknown } | null }> {
  const lanzadas: Lanzada[] = [];
  for (const imagen_id of ids) {
    const executionId = deps.uuid();
    try {
      const r = await deps.regenerar(imagen_id, executionId);
      lanzadas.push({ imagen_id, execution_id: r.execution_id, creditos: r.creditos, formato: r.formato });
    } catch (error) {
      // Se corta acá: si fue por créditos, las siguientes fallarían igual; si fue otra
      // cosa, mejor mostrar el error que seguir encolando a ciegas.
      return { lanzadas, fallo: { imagen_id, error } };
    }
  }
  return { lanzadas, fallo: null };
}
